import { Button } from '@fluentui/react-components';
import { ArrowLeftRegular, ArrowRightRegular } from '@fluentui/react-icons';
import React, { useState, useEffect, FC } from 'react';

type Props = {
  currentPage: number;
  totalCount: number;
  onPageChange: (page: number) => void;
};

const Paginator: FC<Props> = ({ currentPage, totalCount, onPageChange }) => {

  return (
    <div className="flex justify-between mt-4">
      <div>Antal objekt per sida: 50</div>
      <div className='flex gap-2 items-center'>
        <Button disabled={currentPage == 0} onClick={() => onPageChange(currentPage - 1)} icon={<ArrowLeftRegular />}></Button>
        <Button disabled={totalCount < 50 + 50*currentPage} onClick={() => onPageChange(currentPage + 1)} icon={<ArrowRightRegular />}></Button>
        {1+(50*currentPage)} - {(totalCount > (50+(50*currentPage))) ? 50+(50*currentPage) : totalCount} av {totalCount}
      </div>
    </div>
  );
};

export default Paginator;